import styled from 'styled-components';

const inputPadding = 'clamp(0.375rem, 1.9vw, 0.625rem) 0';

export const StyledContainer = styled.div`
  width: 100%;
  max-width: 528px;
  background: ${props => props.theme.colors.greyScale.white};
  border-radius: ${props => props.theme.borderRadius.rounded}px;
  filter: drop-shadow(0px 0.1875rem 0.875rem rgba(78, 71, 69, 0.3));
  padding: clamp(1.5rem, 12vw, 4rem);
  margin: auto clamp(0.5rem, 2vw, 1rem);
  position: relative;
  box-sizing: border-box;

  @media (max-width: 528px) {
    border-radius: 0;
    filter: none;
  }
`;

export const StyledLogoWrapper = styled.div`
  width: 50%;
  min-height: 5rem;
  display: flex;
  align-items: center;
  img {
    max-width: 100%;
    max-height: 5rem;
    height: auto;
  }
`;

export const StyledHeaderDiv = styled.div`
  font-size: clamp(20px, 5.3vw, 28px);
  font-weight: ${props => props.theme.font.weights.medium};
  margin-top: 10px;
  margin-bottom: 20px;
  color: ${props => props.theme.colors.greyScale.title};
`;

export const StyledInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${inputPadding};
  color: ${props => props.theme.colors.greyScale.body};

  section {
    font-size: clamp(1rem, 4.2vw, 1.4rem);
  }
`;

export const StyledSpinnerLoadingContainer = styled.div`
  .spinner {
    transform: scale(0.375);
  }
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const StyledInputErrorText = styled.p`
  margin: 0;
  font-size: ${props => props.theme.font.sizes.sm};
`;

export const StyledCaptchaContainer = styled.div`
  display: flex;
  align-items: center;
  min-height: 3.5rem;
  padding: ${inputPadding};
`;

export const StyledFailedErrorCaptcha = styled.div`
  padding: 0.625rem 0rem;
  color: ${props => props.theme.colors.error.regular};
  font-size: ${props => props.theme.font.sizes.sm};
`;

export const StyledRefreshIconContainer = styled.div`
  margin-left: 1rem;
  path {
    fill: ${props => props.theme.colors.primary.regular};
  }
  &:hover {
    cursor: pointer;
  }
`;

export const StyledCaptchaInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${inputPadding};
  color: ${props => props.theme.colors.greyScale.body};
`;

export const StyledTermsAndConditionsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin: clamp(0.5rem, 2vw, 1rem) 0;
  color: ${props => props.theme.colors.greyScale.body};
`;

export const StyledTermsAndConditionsCheckbox = styled.input`
  margin-top: 0.15rem;
  cursor: pointer;
`;

export const StyledTermsAndConditionsLabel = styled.label`
  font-size: ${props => props.theme.font.sizes.sm};
  line-height: 1.4;
`;

export const StyledTermsAndConditionsLink = styled.a`
  color: ${props => props.theme.colors.primary.regular};
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  button {
    width: 100%;
    margin: clamp(0.5rem, 2vw, 1rem) 0;
  }
`;

export const StyledLanguageSelector = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 20px;
  top: 20px;
`;
